export default __webpack_public_path__ + "static/media/swapActive.0417ce05.svg";